import React from 'react';
import './Courses.css';

const courses = [
  {
    title: 'Web Development',
    description: 'Master HTML, CSS, JavaScript, and modern frameworks to build responsive websites.',
    image: 'https://img.freepik.com/free-photo/website-development-banner_23-2151204926.jpg',
    link: '/courses/web-development',
  },
  {
    title: 'Data Science',
    description: 'Learn data analysis, visualization, and machine learning with Python.',
    image: 'https://img.freepik.com/free-photo/data-science-banner_23-2151204927.jpg',
    link: '/courses/data-science',
  },
  {
    title: 'Digital Marketing',
    description: 'Become an expert in SEO, SEM, social media, and content marketing.',
    image: 'https://img.freepik.com/free-photo/digital-marketing-banner_23-2151204928.jpg',
    link: '/courses/digital-marketing',
  },
  {
    title: 'UX/UI Design',
    description: 'Design user-friendly interfaces and experiences for web and mobile apps.',
    image: 'https://img.freepik.com/free-photo/ui-ux-design-banner_23-2151204929.jpg',
    link: '/courses/ux-ui-design',
  },
];

const Courses = () => (
  <div className="courses-page">
    <div className="container">
      <h1 className="courses-title">Our Courses</h1>
      <div className="courses-grid">
        {courses.map((course, idx) => (
          <div className="course-card" key={idx}>
            <div className="course-image">
              <img src={course.image} alt={course.title} />
            </div>
            <div className="course-content">
              <h3>{course.title}</h3>
              <p>{course.description}</p>
              <a href={course.link} className="course-link">Learn More</a>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Courses; 